import { z } from "zod";

export const Request = z
  .object({
    organisation: z.string(),
    location: z.string(),
  })
  .and(
    z
      .object({
        reservation: z.string(),
      })
      .partial()
      .or(
        z.object({
          release: z.string(),
        }),
      ),
  );

export type Request = z.infer<typeof Request>;
